import { API_ENDPOINTS } from '@/lib/utils/constants';

export const endpoints = {
  auth: {
    login: () => API_ENDPOINTS.AUTH.LOGIN,
    register: () => API_ENDPOINTS.AUTH.REGISTER,
    logout: () => API_ENDPOINTS.AUTH.LOGOUT,
    refresh: () => API_ENDPOINTS.AUTH.REFRESH,
  },
  game: {
    createRoom: () => API_ENDPOINTS.GAME.CREATE_ROOM,
    joinRoom: (roomCode: string) => API_ENDPOINTS.GAME.JOIN_ROOM.replace('{roomCode}', roomCode),
    getRoom: (roomCode: string) => API_ENDPOINTS.GAME.GET_ROOM.replace('{roomCode}', roomCode),
  },
  admin: {
    categories: () => API_ENDPOINTS.ADMIN.CATEGORIES,
    category: (id: string) => `${API_ENDPOINTS.ADMIN.CATEGORIES}/${id}`,
    questions: () => API_ENDPOINTS.ADMIN.QUESTIONS,
    question: (id: string) => `${API_ENDPOINTS.ADMIN.QUESTIONS}/${id}`,
    users: () => API_ENDPOINTS.ADMIN.USERS,
    user: (id: string) => `${API_ENDPOINTS.ADMIN.USERS}/${id}`,
    games: () => `${API_ENDPOINTS.ADMIN.ANALYTICS}/games`,
    game: (id: string) => `${API_ENDPOINTS.ADMIN.ANALYTICS}/games/${id}`,
    lifelines: () => `${API_ENDPOINTS.ADMIN.ANALYTICS}/lifelines`,
    analytics: () => API_ENDPOINTS.ADMIN.ANALYTICS,
  },
};
